<ion-item [formGroup]="form" lines="full">
  <ion-input
    [label]="label"
    [placeholder]="placeholder"
    type="text"
    formControlName="value"
    (ngModelChange)="onInputChange()"
  ></ion-input>
  <ion-buttons slot="end">
    @if (!isLoading && !successMessage) {
      <ion-button (click)="onClickConfirmButton()">
        {{ buttonLabel }}
      </ion-button>
    }
    @if (isLoading) {
      <ion-button>
        <ion-spinner></ion-spinner>
      </ion-button>
    }
    @if (successMessage) {
      <ion-button color="success">
        <ion-icon name="checkmark"></ion-icon>
      </ion-button>
    }
  </ion-buttons>
  @if (errorMessage) {
    <ion-label slot="error" style="max-width: 100%">
      <ion-text color="danger">{{ errorMessage }}</ion-text>
    </ion-label>
  }
  @if (successMessage) {
    <ion-label slot="helper" style="max-width: 100%">
      <ion-text color="success">{{ successMessage }}</ion-text>
    </ion-label>
  }
</ion-item>
